<rpshared-save-bar 
	title="{{ form.value.firstName }} {{ form.value.lastName }}" 
	[isSaving]="isSaving$ | async"
	[isFormInvalid]="isFormInvalid$ | async" 
	(save)="save($event)">
</rpshared-save-bar>

<div [formGroup]="form" gdGap="10px" class="with-fixed-sub-toolbar">
	<mat-card>
		<mat-progress-bar 
			mode="indeterminate" 
			class="mat-card-loading" 
			*ngIf="isLoading$ | async">
		</mat-progress-bar>
		<rpshared-card-title icon="verified_user" title="Customer User Details"></rpshared-card-title>
		<div gdGap="8px" gdColumns="repeat(auto-fill, minmax(350px, 1fr))">
			<mat-form-field>
				<input 
					matInput 
					placeholder="First Name" 
					formControlName="firstName" 
					autofocus 
				/>
			</mat-form-field>
			<mat-form-field>
				<input 
					matInput 
					placeholder="Last Name" 
					formControlName="lastName" 
				/>
			</mat-form-field>
			<mat-form-field>
				<input 
					matInput 
					placeholder="Email" 
					formControlName="email" 
					type="email" 
				/>
			</mat-form-field>

			<rpshared-customer-link formControlName="customer"></rpshared-customer-link>

			<rpshared-multi-chip-input 
				gdColumn="1 / -1" 
				placeholder="Role" 
				formControlName="roles"
			></rpshared-multi-chip-input>
		</div>
	</mat-card>
</div>
